import {useMemo} from 'react';
import type {
  ActualChangesWithSchema,
  MetadataChangesInfo,
} from 'services/metadata/types';
import type {RootState} from 'store/types';
import {useCreateSelectorById} from 'services/metadata/hooks/useCreateSelectorById';
import {useAppSelector} from 'store/hooks';
import type {ItemsCompletedStatus} from '../../../types';

const NoChanges: MetadataChangesInfo = {rootPaths: [], arraysUpdateHistory: {}};

const changesInfoSelectorById =
  (id: string | undefined) => (state: RootState) =>
    id ? (state.metadataEdit.approvedChanges[id] ?? NoChanges) : NoChanges;

export const useChangeRequestItemsCompletedStatus = (
  changes: ActualChangesWithSchema | undefined,
): {
  itemCompletedStatus: ItemsCompletedStatus;
  isCompleted: boolean;
  rootPaths: string[];
} => {
  const selector = useCreateSelectorById(changes?.id, changesInfoSelectorById);
  const changesInfo = useAppSelector(selector);
  return useMemo(() => {
    const {rootPaths, isCompleted} = changesInfo;
    const resolvedIsCompleted =
      isCompleted ?? (changes?.paths ?? []).every(p => rootPaths.includes(p));
    return {
      isCompleted: resolvedIsCompleted,
      itemCompletedStatus: (resolvedIsCompleted
        ? 'All'
        : rootPaths.length === 0
          ? 'None'
          : 'Some') as ItemsCompletedStatus,
      rootPaths,
    };
  }, [changes, changesInfo]);
};
